import { CoordinatorService } from './coordinator.service';
import { KeywordEdit } from './keyword-edit';
import { KeywordGroup } from './keyword-group';
import { ScriptKeyword } from './script-keyword';
import { STG } from './stage';

export type K = {
    id?: string;
    regexp?: string;
    weight?: number;
    groupId?: string;
};

export class Keyword {
    id: string;
    weight: number;
    private _regexp: RegExp | undefined;
    seed: string | undefined;
    groupId: string;
    lastCorrectPattern: string | undefined;
    private _kwEdit: KeywordEdit | undefined;

    constructor(
        public coords: CoordinatorService,
        params: K,
    ) {
        this.id = params.id || this.coords.uniqueId();
        this._regexp = params.regexp ? new RegExp(params.regexp, 'gid') : undefined;
        this.weight = params.weight === undefined ? 1 : params.weight;
        this.groupId = params.groupId || '_default';
    }

   

    get group() {
        let grp = this.coords.keyword$.getGroup(this.groupId);
        if (!grp) {
            this.groupId = '_default';
            grp = this.coords.keyword$.getGroup(this.groupId);
        }
        return grp!;
    }

    title = this.source;

    get source() {
        return this._regexp ? this._regexp.source : '';
    }

    get regexp() {
        return this._regexp;
    }

    get isReady() {
        return !!this._regexp;
    }

    preview(tp: 'collection' | 'preview' | 'main') {
        const stg = this.coords.stage$.current.tag;

        if (tp === 'main') tp = 'collection';
        this.coords.resultList$.activateSubset({
            idSet: this.coords.keyword$.kwId2XItemIdSet(this.id, tp === 'preview'),
            title: this.title,
            prefix: this.coords.text('keyword'),
            icon: 'keyword',
            class: 'selection-in-general',
            back: () => this.coords.stage$.set(stg),
            stage: tp,
        });
    }

    save(): K {
        const dct: K = {
            id: this.id,
            regexp: this._regexp?.source,
            weight: this.weight,
            groupId: this.groupId,
        };
        return dct;
    }

    get sortTag() {
        return this.source?.trim().toLowerCase();
    }

    setRegexp(txt: string) {
        try {
            this._regexp = new RegExp(txt, 'ig');
            return true;
        } catch (e) {
            if (this._regexp) this.lastCorrectPattern = this._regexp.source;
            this._regexp = undefined;
            return false;
        }
    }

    delete() {
        this.coords.keyword$.delete(this);
    }

    get deleteParams() {
        return {
            icon: 'delete',
            fun: () => this.delete(),
        };
    }

    get activeIdLs() {
        return Array.from(
            this.coords.keyword$.kwId2XItemIdSet(
                this.id,
                this.coords.stage$.datasetTag === 'preview',
            ),
        );
    }

    size(tp: 'main' | 'preview') {
        const s = this.idSet(tp);
        return s.size;
    }

    idSet(tp: 'main' | 'preview') {
        return this.coords.keyword$.kwId2XItemIdSet(this.id, tp === 'preview');
    }

    update(params: { source: string; weight: number; group: KeywordGroup }) {
        if (!this.setRegexp(params.source)) return;

        if (params.weight !== undefined) this.weight = params.weight || 0;

        this.groupId = params.group.id;

        this.coords.keyword$.update(this);
    }

    test(txt: string) {
        return this._regexp?.test(txt);
    }

    get style() {
        return this.group?.style?.css;
    }

    get scriptClass() {
        return new ScriptKeyword(this.coords, this);
    }
}
